/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_Col_PeopleInputs */

const vi_station_work_col_people = /** @type {(inputs: Station_Work_Col_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người tham gia`)
};

/**

* @param {Station_Work_Col_PeopleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_col_people = /** @type {((inputs?: Station_Work_Col_PeopleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Col_PeopleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_col_people(inputs)
});